import * as XLSX from 'xlsx';

export default function GeraXLSX({data,headers,fields,titulo}){
    let campos_relatorio = [];
    let campos = {};
    for(let i=0;i < data.length ;i++){
        for(let j=0;j < fields.length ;j++){
            campos[fields[j]] = (data[i][fields[j]])
        }
        campos_relatorio[i] = campos
        campos = {}
    }

    const ws = XLSX.utils.json_to_sheet(campos_relatorio, { origin: 'A1' })
    XLSX.utils.sheet_add_json(ws, [], { origin: 'A1', header: headers })

    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Relatorio')
    XLSX.writeFile(wb,`${titulo}.xlsx`)
}
